<div class="app-frame mat-app-background">
  <app-nav></app-nav>
</div>